<template>
  <div class="d-flex" style="height: 100%">
    <div style="width: 100%">
      <base-map />
    </div>
    <div v-if="isShowMapDetail" style="border-left: 1px solid #c1c1c1">
      <v-toolbar dense flat color="primary" height="36">
        <v-card class="body-2 white--text" color="primary" flat width="320">
          {{ mapDetail.title }}
        </v-card>
        <v-spacer />
        <v-btn class="mr-1" dark icon small @click="closeMapDetail">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card
        tile
        flat
        height="calc(100vh - 40px)"
        width="400"
        style="overflow-y: auto;"
      >
        <template v-if="mapDetail.contents === 'stage-detail'">
          <StageDetail />
        </template>
        <template v-if="mapDetail.contents === 'rainfall-detail'">
          <RainDetail />
        </template>
        <template v-if="mapDetail.contents === 'dam-detail'">
          <DamDetail />
        </template>
        <template v-if="mapDetail.contents === 'camera-detail'">
          <CameraDetail />
        </template>
        <template v-if="mapDetail.contents === 'live-camera-detail'">
          <LiveCameraDetail />
        </template>
        <template v-if="mapDetail.contents === 'manhole-detail'">
          <ManholeLevelDetail />
        </template>
        <template v-if="mapDetail.contents === 'waterway-detail'">
          <WaterwayDetail />
        </template>
        <template v-if="mapDetail.contents === 'pump-detail'">
          <PumpDetail />
        </template>
        <template v-if="mapDetail.contents === 'suijin-detail'">
          <SuijinDetail />
        </template>
      </v-card>
    </div>
    <monitoring v-if="isMonitoring" />
    <ManholeMonitor v-if="isManholeMonitor && !isShowMapDetail" />
    <CameraMonitor v-if="isCameraMonitor && !isShowMapDetail" />
    <RightSideContents v-if="isRightSideContents && !isShowMapDetail" />

    <v-snackbar v-model="snackbar" top :timeout="-1" :color="snackbarColor">
      <div class="snack-text">{{ snackbarText }}</div>
      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          small
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          閉じる
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import moment from "moment";
import { Risk } from "../enums/Risk";
import { OBSERVATORY } from "../enums/Type";
import BaseMap from "../components/base-map/BaseMap";
import Monitoring from "../components/Monitoring";
import ManholeMonitor from "../components/ManholeMonitor";
import StageDetail from "../components/base-map/details/StageDetail";
import RainDetail from "../components/base-map/details/RainDetail";
import DamDetail from "../components/base-map/details/DamDetail";
import CameraDetail from "../components/base-map/details/CameraDetail";
import LiveCameraDetail from "../components/base-map/details/LiveCameraDetail";
import CameraMonitor from "../components/CameraMonitor";
import RightSideContents from "../components/RightSideContents";
import ManholeLevelDetail from "@/components/base-map/details/ManholeLevelDetail";
import WaterwayDetail from "@/components/base-map/details/WaterwayDetail";
import PumpDetail from "@/components/base-map/details/PumpDetail";
import { isPublicMode, isPrivateMode } from "../utils/common";
import SuijinDetail from "../components/base-map/details/SuijinDetail";

export default {
  name: "Dashboard",
  components: {
    WaterwayDetail,
    ManholeLevelDetail,
    Monitoring,
    ManholeMonitor,
    BaseMap,
    StageDetail,
    RainDetail,
    DamDetail,
    CameraDetail,
    LiveCameraDetail,
    CameraMonitor,
    RightSideContents,
    PumpDetail,
    SuijinDetail
  },
  data() {
    return {
      Risk,
      snackbar: false,
      snackbarText: "",
      snackbarColor: "#AD02AD"
    };
  },
  computed: {
    selectedRisk() {
      return this.$store.getters.selectedRisk;
    },
    isShowMapDetail() {
      return this.$store.getters.isShowMapDetail;
    },
    mapDetail() {
      return this.$store.getters.mapDetail;
    },
    isMonitoring() {
      return this.$store.getters.isMonitoring;
    },
    isManholeMonitor() {
      return this.$store.getters.isManholeMonitor;
    },
    isCameraMonitor() {
      return this.$store.getters.isCameraMonitor;
    },
    baseDate() {
      return this.$store.getters.baseDate;
    },
    isRightSideContents() {
      return (
        this.$store.getters.isRightNavVisible === true &&
        this.$route.path === "/"
      );
    },
    observatories() {
      return this.$store.getters.observatories;
    }
  },
  watch: {
    selectedRisk() {
      this.closeMapDetail();
    },
    baseDate() {
      if (this.isShowMapDetail !== true) {
        return;
      }
      const info = this.$store.getters.selectedObservatory;
      this.$store.dispatch("FETCH_SELECTED_OBSERVATORY_DATA", info);
    },
    observatories() {
      if (this.observatories.length > 0 && isPrivateMode === true) {
        const baseDate = this.baseDate.format("YYYYMMDDHHmm");
        const now = moment.utc().format("YYYYMMDDHHmm");
        if (baseDate === now) {
          this.showManholeAlert();
        }
      }
    }
  },
  mounted() {
    //
  },
  methods: {
    closeMapDetail() {
      const dialog = {
        isShowing: false
      };
      this.$store.commit("SET_MAP_DETAIL", dialog);
    },
    showManholeAlert() {
      if (isPublicMode === true) {
        return;
      }
      const manholes = this.observatories.filter(
        obs =>
          obs.type === OBSERVATORY.MANHOLE.code ||
          obs.type === OBSERVATORY.MANHOLE_WATERWAY.code
      );
      const storageKey = "manhole-alert";
      const isDangerous = manholes.some(obs => obs.status === "dangerous");
      const isWarning = manholes.some(obs => obs.status === "warning");
      const status = isDangerous ? "dangerous" : isWarning ? "warning" : "";
      if (status === "") {
        console.log("No alert to show.");
        return;
      }

      const storageData = localStorage.getItem(storageKey);
      if (storageData) {
        const data = JSON.parse(storageData);
        const expDate = moment
          .utc()
          .subtract(1, "hours")
          .format("YYYY/MM/DD HH:mm");
        if (
          data.utc > expDate &&
          (data.status === status || data.status === "dangerous")
        ) {
          console.log("Alert already shown.");
          return;
        }
      }

      localStorage.setItem(
        storageKey,
        JSON.stringify({
          status: status,
          utc: moment.utc().format("YYYY/MM/DD HH:mm")
        })
      );

      this.snackbarText =
        status === "dangerous"
          ? "道路面までの8割水位を超過しているマンホール/水路があります。"
          : "道路面までの5割水位を超過しているマンホール/水路があります。";
      this.snackbarColor = status === "dangerous" ? "#AD02AD" : "#FFA500";
      this.snackbar = true;
    }
  }
};
</script>

<style scoped>
.v-snack--top {
  z-index: 4000 !important;
}
.snack-text {
  color: white;
  font-weight: bold;
  text-shadow: 1px 1px 0 #2c2c2c, -1px 1px 0 #2c2c2c, 1px -1px 0 #2c2c2c,
    -1px -1px 0 #2c2c2c;
}
</style>
